import "./DisplayPostPage.scss";
import Slider from "../../components/slider/Slider";
import Map from "../../components/map/Map";
import { useLoaderData, useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";
import { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../context/AuthContext";
import apiRequest from "../../lib/apiRequest";
import { Helmet } from "react-helmet";
import { generatePostMessage } from "../../lib/allPurposeFunctions";




import pin from "../../assets/pin.png";
import noavatar from "../../assets/noavatar.png";
import size from "../../assets/size.png";
import bed from "../../assets/bed.png";
import bath from "../../assets/bath.png";
// import chat from "../../assets/chat.png";
import save from "../../assets/save.png";
import CommunicationItem from "../../components/communicationitem/CommunicationItem";
import { isLocalhost } from "../../../checkLocalhost";

import SharePostButton from "../../components/sharepost/SharePostButton";
import { BookmarkIcon, ChatIcon } from "../../lib/myIcons";
import BhoomiSlider from "../../components/basicslider/BhoomiSlider";
import CancelButton from "../../components/buttons/cancelbutton/CancelButton";

function DisplayPostPage() {
  const dataObj = useLoaderData();
  const navigate = useNavigate();
  const { currentUser } = useContext(AuthContext);

  // ✅ define post immediately from loader
  const postResponse = dataObj?.postResponse;

  // console.log("Post Response: ",postResponse)

  const [post, setPost] = useState(postResponse || null);
  const [hasSaved, SethasSaved] = useState(postResponse?.savedpost || false);
  const [hasMessaged, setHasMessaged] = useState(postResponse?.messaged ||false);

  // ✅ update states only if loader gives new data
  useEffect(() => {
    if (postResponse) {
      setPost(postResponse);
      SethasSaved(postResponse.savedpost || false);
      setHasMessaged(postResponse.messaged || false);
      
    }
  }, [postResponse]);

  const handleUserProfileClick = (userId) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(`/displayprofile/${userId}`);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!currentUser) {
      navigate("/login");
      return;
    }
    // SetSaved((prev) => !prev);

    // console.log("dddddddddd")
    try {
      // await apiRequest.post("/users/save", { postid: post.id });
      const res=await apiRequest.post("/users/save",{postid:post.id})
        // console.log("post response:", res.data);    

    } catch (err) {
      console.log(err);
    }

      SethasSaved((prev) => !prev);

  };

  const handleSendMessage = (myPost) =>  (e) => {
    e.preventDefault();
    console.log("sending message with post ",post);


    if (!currentUser) {
      navigate("/login");
      return;
    }

    if(hasMessaged=='1') {
      alert("You have already sent a message for this property.");
      return; // Exit if the user has already messaged

    }
    const message = generatePostMessage(myPost,currentUser.username);  
    // console.log("Message to send:", message);

    const postChatMessage= async() => { 
      try {      
        const res= await apiRequest.post("/chats/chatmessage", {
          receiverid: myPost.userid,
          text: message,
          postid: myPost.id, // Pass the post ID
        });
        console.log("Chat response:", res.data);
        // console.log("Chat ID:", res.data.id);
        // const message="Hello, I would like to inquire about the property you posted. Could you please provide more details? Thank you!";
        setHasMessaged(true);         // local highlight

      }
      catch (error) {
        console.error("Error sending message:", error);
      }
    }
    postChatMessage();







    


  };

  if (!post) return <div>Loading post...</div>; // ✅ safe guard


  
  // const postimagelocation =
  //   import.meta.env.VITE_IS_LOCALHOST === "true"

  const avatarfolder=import.meta.env.VITE_AVATARIMAGE_FOLDER
  const postfolder=import.meta.env.VITE_POSTIMAGE_FOLDER

  const postimagelocation =isLocalhost
      ? import.meta.env.VITE_POSTIMAGES_BASEURL + post.userid + postfolder
      : import.meta.env.VITE_POSTIMAGES_SH_BASEURL + post.userid + postfolder

  // const avatarimagelocation =
  //   import.meta.env.VITE_IS_LOCALHOST === "true"

  const avatarimagelocation =isLocalhost
      ? import.meta.env.VITE_AVATARIMAGES_BASEURL + post.userid + avatarfolder
      : import.meta.env.VITE_AVATARIMAGES_SH_BASEURL + post.userid + avatarfolder;


  return (
    <div className="displayPostPage">
      <Helmet>
        <meta name="description" content={post.description} />
        <meta property="og:title" content={post.title} />
        <meta property="og:description" content={post.description} />

        <meta property="og:image" content={post?.avatarUrl} />

        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={post.title} />
        <meta name="twitter:description" content={post.description} />

        <meta name="twitter:image" content={post?.avatarUrl} />

      </Helmet>

      <div className="postContainer">

        <div className="postRow postcols">
          <div className="firstCol">
            <div className="PostImageswrapper">
                <Slider
                  images={post.images}
                  postid={post.id}
                  userid={post.userid}
                  builderpost={post.builderpost}
                  
                />
              {post.latitude!='' || post.longitude !=='' &&(
                <div className="mapContainer">
                  <Map items={[post]} />
                </div>

              )}


              <div className="postDescription">

                  <div className="Descriptionwrapper">
                    <div className="info">
                      <div className="post">
                        <h1>{post.title}</h1>
                        <p className="transtype">
                          {post.propertytypetag + " " + post.transtypetag}
                        </p>
                        <div className="address">
                          <img className="iconImage"  src={pin} alt="" />
                          <span>
                            {[
                              post.block,
                              post.plotno,
                              post.address1,
                              post.address2,
                              post.colonyname,
                              post.city,
                            ]
                              .filter(Boolean)
                              .join(", ")}
                          </span>
                        </div>
                        <div className="price">Rs. {post.price}</div>
                      </div>
                    </div>

                    
                    <div className="description">
                      <label className="title">Description</label>
                      <div
                        className="quill-content"
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(post.description),
                        }}
                      />
                    </div>

                    <div className="generalTags">
                      <label className="title">Features</label>
                      {post.tags}
                    </div>

                    <div className="details">

                      <label className="title">Details</label>
                      <div className="sizes">
                        <div className="size">
                          <img className="iconImage" src={size} alt="" />
                          <span>{post.plotsize + " " + post.plotsizename}</span>
                        </div>
                        <div className="size">
                          <img className="iconImage" src={bed} alt="" />
                          <span>{post.bedroom} beds</span>
                        </div>
                        <div className="size">
                          <img className="iconImage" src={bath} alt="" />
                          <span>{post.bathroom} bathroom</span>
                        </div>


                      </div>
                    </div>


                    <div className="postUser">
                      <div className="userButton"                           
                        onClick={handleUserProfileClick(post.userid)}>

                        <button
                          className="user"
                        >
                          <img
                            src={
                              post.avatar && post.avatar.startsWith("http")
                                ? post.avatar || noavatar
                                : avatarimagelocation + `${post.avatar}` || noavatar
                            }
                            alt=""
                          />
                        </button>
                        <div className="userCompany">
                            <span>{post.clienttype}</span>
                            <span>{post.companyname}</span>

                          </div>

                      </div>
                      
                      <div className="userComm">
                        {post.phone && (
                          <CommunicationItem
                            type="phone"
                            display={post.phone}
                            ItemPostId={post.id}
                            ItemUserId={currentUser ? currentUser.id : null}
                          />
                        )}

                        {post.mobile && (
                          <CommunicationItem
                            type="whatsapp"
                            display={post.mobile}
                            ItemPostId={post.id}
                            ItemUserId={currentUser ? currentUser.id : null}
                          />
                        )}

                        {post.email && (
                          <CommunicationItem
                            type="email"
                            display={post.email}
                            ItemPostId={post.id}
                            ItemUserId={currentUser ? currentUser.id : null}
                          />
                        )}
                      </div>



                    </div>


                  </div>


              </div>
    
            </div>
    

          </div>

          <div className="secondCol">
            
              <div className="advertisementContainer">
                                {/* this will contain post specific advertisements

                                  free Registration
                                  free listing
                                  free reposts
                              
                                make another section for colony specific posts 
                                make another section for colony specific brokers */}
                
                                <BhoomiSlider></BhoomiSlider>
                
                
                      </div>


          </div>

        </div>

        
        <div className="postRow">
        
        </div>



      </div>



          <div className="buttons">
            <button
              onClick={handleSendMessage(post)}
              // style={{
              //   color: "black",
              //   backgroundColor: hasMessaged == "1" ? "#fece51" : "transparent",
              // }}
            >
            <ChatIcon size={24} color="white"></ChatIcon>

              Send a Message
            </button>

            {/* {console.log("Saved while rendering: ",saved)} */}

            <button
              onClick={handleSave}
              // style={{
              //   color: "black",
              //   backgroundColor: hasSaved == "1" ? "#fece51" : "transparent",
              // }}
            >
              {/* <img className="iconImage" src={save} alt="" /> */}
              <BookmarkIcon size={24} color="white">

              </BookmarkIcon>

              {hasSaved == "1" ? "Post Saved" : "Save the Post"}
            </button>
            <SharePostButton
              PostId={post.id}
              isLocalHost={isLocalhost}
              PostObject={post}
              
            ></SharePostButton>
            <CancelButton></CancelButton>



          </div>



    </div>
  );
}

export default DisplayPostPage;
